"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaReportEvaluationHeader = void 0;
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _Header = _interopRequireDefault(require("../../components/Header"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const KansaReportEvaluationHeader = props => {
  const {
    kansaTgtNendoNm,
    kansaThemeNm,
    hikansabumon
  } = props.entries;
  return /*#__PURE__*/_react.default.createElement(_Header.default, {
    itemList: [{
      labelId: _labelConsts.LABEL.KANSA_AUDIT_YEAR,
      value: kansaTgtNendoNm
    }, {
      labelId: _labelConsts.LABEL.KANSA_AUDIT_THEME,
      value: kansaThemeNm
    }, {
      labelId: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON,
      value: hikansabumon
    }]
  });
};
exports.KansaReportEvaluationHeader = KansaReportEvaluationHeader;
var _default = exports.default = KansaReportEvaluationHeader;